module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', _vm._l((_vm.options), function(item) {
    return _c('div', [_c('RadioOption', {
      attrs: {
        "name": _vm.name,
        "value": item.value
      }
    }, [_vm._v("\n      " + _vm._s(item.label) + "\n    ")])], 1)
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-583b8f50!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Lesson1/components/RadioOptionGroup.vue
// module id = 30
// module chunks = 0